import { Box } from "@chakra-ui/react";
import HeaderTable from "./components/HeaderTable";
import ItemTable from "./components/ItemTable";
import FooterTable from "./components/FooterTable";
import { Empty } from "antd";
import { Control, ControllerRenderProps } from "react-hook-form";
import Field from "ui/components/Input/Field";
import {
  OrcamentoCotacaoItemForm,
  OrcamentoCotacaoItem,
} from "features/orcamento/typings";

interface TableItensFornecedorProps {
  form?: OrcamentoCotacaoItemForm;
  control: Control<OrcamentoCotacaoItemForm, any>;
  orcamentoId?: string;
}

export default function TableItensFornecedor({
  control,
  form,
  orcamentoId,
}: TableItensFornecedorProps) {
  const onEditRow = (
    field: ControllerRenderProps<OrcamentoCotacaoItem, any>,
    value: Partial<OrcamentoCotacaoItem>,
    index: number
  ) => {
    const copy = [...field.value];

    copy.splice(index, 1, { ...field.value[index], ...value });

    field.onChange(copy);
  };

  const onRemoveItem = (
    field: ControllerRenderProps<any, any>,
    index: number
  ) => {
    const copy = [...field.value];

    copy.splice(index, 1);

    field.onChange(copy);
  };

  const orcamentoCotacaoItems = form?.orcamentoCotacaoItems || [];

  const total =
    form?.valorTotal ??
    orcamentoCotacaoItems.reduce(
      (acc, next) =>
        (acc += (next.quantidade ?? 0) * (next.valorUnitario ?? 0)),
      0
    ) ??
    0;

  return (
    <Box>
      <HeaderTable />

      {!orcamentoCotacaoItems.length ? (
        <Box mt={4}>
          <Empty description="Sem itens." />{" "}
        </Box>
      ) : null}

      <Field
        control={control}
        name="orcamentoCotacaoItems"
        shouldUnregister
        rules={{
          validate: (v) => {
            if (v) {
              return (
                v.every(
                  (item: OrcamentoCotacaoItem) =>
                    !!item?.orcamentoItemId &&
                    !!item?.unidadeMedidaId &&
                    !!item?.quantidade &&
                    (!!item?.valorUnitario || !!item?.indisponivel)
                ) || "Todos os campos devem estar preenchidos"
              );
            }
            return true;
          },
        }}
        render={({ field, isInvalid }) =>
          field.value
            ? field.value.map((item: OrcamentoCotacaoItem, index: number) => (
                <ItemTable
                  orcamentoId={orcamentoId}
                  key={item.id}
                  item={item}
                  onRemoveItem={onRemoveItem}
                  indexItem={index}
                  onEditRow={onEditRow}
                  field={field}
                  isInvalid={isInvalid}
                />
              ))
            : null
        }
      />
      {orcamentoCotacaoItems.length ? (
        <FooterTable totalItens={orcamentoCotacaoItems.length} total={total} />
      ) : null}
    </Box>
  );
}
